import { PaymentCreate } from './PaymentCreate';
import { PaymentsList } from './PaymentsList';
import PaymentsIcon from '@mui/icons-material/Payments';
import { PaymentShow } from './PaymentShow';

const Payments = {
  create: PaymentCreate,
  // list: PaymentsList,
  show: PaymentShow,
  icon: PaymentsIcon,
};

export default Payments;
